var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"y-center",staticStyle:{"background":"none","padding":"16px 0"}},[(_vm.title)?_c('div',{staticClass:"size-md bolder",staticStyle:{"margin-right":"10px"}},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }